import { render, staticRenderFns } from "./MsgElementBusinessCard.vue?vue&type=template&id=130da5c2&scoped=true"
import script from "./MsgElementBusinessCard.vue?vue&type=script&lang=js"
export * from "./MsgElementBusinessCard.vue?vue&type=script&lang=js"
import style0 from "./MsgElementBusinessCard.vue?vue&type=style&index=0&id=130da5c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130da5c2",
  null
  
)

export default component.exports